"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isEqual2 = _interopRequireDefault(require("lodash/isEqual"));

var _react = _interopRequireWildcard(require("react"));

var _text = require("@mmc/text");

var _mmcDataUtilities = _interopRequireDefault(require("@mmc-tools/mmc-data-utilities"));

var _paymentCalculatorForm = require("@mmc/payment-calculator-form");

var _commonErrorBoundary = require("@mmc/common-error-boundary");

var _configuratorSmallSummary = _interopRequireDefault(require("../styles/configurator-small-summary.css"));

var _configurationTextBlock = _interopRequireDefault(require("./configuration-text-block"));

var _accordionWrapper = _interopRequireDefault(require("./accordion-wrapper"));

var _configuratorImage = _interopRequireDefault(require("./configurator-image"));

var _toggleBar = _interopRequireDefault(require("./toggle-bar"));

var _configuratorSmallSummary2 = _interopRequireDefault(require("./configurator-small-summary.props/configurator-small-summary.defaultProps"));

var _configuratorSmallSummary3 = _interopRequireDefault(require("./configurator-small-summary.props/configurator-small-summary.propTypes"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

/**
 * ## ConfiguratorSmallSummary - component
 *
 * Summary Drawer for Configurator Component
 */
var paymentCalcMarkets = ['us', 'ca'];
var SmallSummaryInstances = 0;
var dataUtils = new _mmcDataUtilities["default"]();
var shouldUseDataOrDefaultProps = dataUtils.shouldUseDataOrDefaultProps,
    handleNestedProp = dataUtils.handleNestedProp;

var ConfiguratorSmallSummary = function ConfiguratorSmallSummary(_ref) {
  var data = _ref.data,
      theme = _ref.theme,
      defaultData = _ref.defaultData,
      nextStepLabel = _ref.nextStepLabel,
      isDocked = _ref.isDocked,
      stepId = _ref.stepId,
      rootUrl = _ref.rootUrl,
      market = _ref.market,
      id = _ref.id,
      nextButtonEvent = _ref.nextButtonEvent,
      changeModel = _ref.changeModel,
      changeColor = _ref.changeColor,
      changeFabric = _ref.changeFabric,
      changePackage = _ref.changePackage,
      changeAccessories = _ref.changeAccessories,
      direction = _ref.direction,
      summaryExpanded = _ref.summaryExpanded,
      addPriceDisclaimer = _ref.addPriceDisclaimer,
      priceDisclaimerId = _ref.priceDisclaimerId,
      disclaimerData = _ref.disclaimerData;

  var _id = id || "small-summary-" + (SmallSummaryInstances + 1);

  var _useState = (0, _react.useState)(summaryExpanded),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var _useState2 = (0, _react.useState)(false),
      hasFinance = _useState2[0],
      setHasFinance = _useState2[1];

  var _useState3 = (0, _react.useState)({
    leaseFor: null,
    suffix: null
  }),
      finance = _useState3[0],
      setFinance = _useState3[1];

  var componentData = shouldUseDataOrDefaultProps(data, defaultData);
  var vehicleImage = handleNestedProp(componentData, 'componentData.selectedVehicleImage');
  if (vehicleImage === ' ') vehicleImage = {};

  var handleFinance = function handleFinance(newData) {
    // Prevent infinite rerender loop
    if (!(0, _isEqual2["default"])(_objectSpread(_objectSpread({}, finance), newData), finance)) {
      setHasFinance(true);
      setFinance(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), newData);
      });
    }
  };

  var togglePanelExpand = function togglePanelExpand() {
    if (typeof window !== 'undefined') {
      var width = window.innerWidth || -1;

      if (width > 0 && isExpanded === false) {
        document.body.classList.add(_configuratorSmallSummary["default"].preventScroll); // eslint-disable-line
      } else {
        document.body.classList.remove(_configuratorSmallSummary["default"].preventScroll);
      }
    }

    setIsExpanded(!isExpanded);
  };

  var disclaimerGroup = {
    addPriceDisclaimer: addPriceDisclaimer,
    priceDisclaimerId: priceDisclaimerId,
    disclaimerData: disclaimerData,
    msrpDisclaimerId: componentData.msrpDisclaimerId,
    monthlyMsrpDisclaimerId: componentData.monthlyMsrpDisclaimerId,
    buyMonthlyDisclaimerId: componentData.buyMonthlyDisclaimerId,
    interestRateDisclaimerId: componentData.interestRateDisclaimerId,
    leaseMonthlyDisclaimerId: componentData.leaseMonthlyDisclaimerId,
    annualMileageDisclaimerId: componentData.annualMileageDisclaimerId,
    dueAtLeaseSigningDisclaimerId: componentData.dueAtLeaseSigningDisclaimerId,
    destinationFeesDisclaimerId: componentData.destinationFeesDisclaimerId
  };
  var additionalPriceGroup = {
    color: componentData.color ? componentData.color.price.value : 0,
    colorCode: componentData.color && componentData.color.code,
    fabric: componentData.fabric ? componentData.fabric.price.value : 0,
    fabricCode: componentData.fabric && componentData.fabric.code,
    "package": componentData.packages ? componentData.packages.reduce(function (a, b) {
      return a + b.price.value;
    }, 0) : 0,
    packageCodes: componentData.packages && componentData.factoryInstalledOptionCodes && componentData.packages.map(function (p) {
      return p.code;
    }).filter(function (v) {
      return !componentData.factoryInstalledOptionCodes.includes(v);
    }),
    accessory: componentData.accessories ? componentData.accessories.reduce(function (a, b) {
      return a + b.price.value;
    }, 0) : 0,
    accessoryCodes: componentData.accessories && componentData.accessories.map(function (a) {
      return a.code;
    }),
    destinationFees: componentData.totalPrice && componentData.totalPrice.fees ? componentData.totalPrice.fees.reduce(function (a, b) {
      return a + b.value;
    }, 0) : 0
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].summaryWrapper + " " + (isExpanded ? _configuratorSmallSummary["default"].isExpanded : '') + " " + (isDocked === true ? _configuratorSmallSummary["default"].isDocked : '')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    role: "presentation",
    className: _configuratorSmallSummary["default"].exclusionZone,
    onClick: togglePanelExpand,
    onKeyDown: function onKeyDown(ev) {
      return ev.key === 13 ? togglePanelExpand : true;
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].innerWrapper + " " + theme['container-fluid'] + " "
  }, /*#__PURE__*/_react["default"].createElement(_toggleBar["default"], {
    hasFinance: hasFinance,
    financeAmount: finance.leaseFor,
    financeSuffix: finance.suffix,
    theme: theme,
    id: _id,
    toggleEvent: togglePanelExpand,
    data: componentData,
    isExpanded: isExpanded,
    nextButtonEvent: nextButtonEvent,
    nextStepLabel: nextStepLabel,
    stepId: stepId,
    market: market,
    disclaimerGroup: disclaimerGroup
  }), /*#__PURE__*/_react["default"].createElement("div", {
    id: _id,
    className: "" + _configuratorSmallSummary["default"].expandablePanel,
    "aria-expanded": isExpanded,
    "aria-selected": isExpanded
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _configuratorSmallSummary["default"].summaryRow + " " + theme.row
  }, /*#__PURE__*/_react["default"].createElement(_configuratorImage["default"], {
    theme: theme,
    vehicleImage: vehicleImage
  }), /*#__PURE__*/_react["default"].createElement(_configurationTextBlock["default"], {
    theme: theme,
    data: componentData,
    changeModel: changeModel,
    rootUrl: rootUrl,
    direction: direction,
    market: market,
    hidePrice: true,
    hideChange: true
  }), /*#__PURE__*/_react["default"].createElement(_accordionWrapper["default"], {
    theme: theme,
    data: componentData,
    market: market,
    changeColor: changeColor,
    changeFabric: changeFabric,
    changePackage: changePackage,
    changeAccessories: changeAccessories,
    direction: direction,
    disclaimerGroup: disclaimerGroup,
    additionalPriceGroup: additionalPriceGroup
  }), paymentCalcMarkets.includes(market) && /*#__PURE__*/_react["default"].createElement(_commonErrorBoundary.CommonErrorBoundary, {
    errorMsg: "PaymentCalculator has caught an error"
  }, /*#__PURE__*/_react["default"].createElement(_paymentCalculatorForm.CalculationForm, {
    isSmallForm: true,
    theme: theme,
    inlineData: componentData,
    updatePriceHoc: handleFinance,
    disclaimerGroup: disclaimerGroup,
    additionalPriceGroup: additionalPriceGroup,
    isBackgroundWhite: true
  }))))));
};

ConfiguratorSmallSummary.resourceType = function () {
  return 'SmallSummary_1_0_0';
};

ConfiguratorSmallSummary.displayName = 'ConfiguratorSmallSummary';
ConfiguratorSmallSummary.defaultProps = {
  data: _configuratorSmallSummary2["default"],
  defaultData: _configuratorSmallSummary2["default"]
};
var _default = ConfiguratorSmallSummary;
exports["default"] = _default;